import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import "nprogress/nprogress.css";
import "./style/index.css";
import "./style/table.css";
import MapMenusToRouter from "@/router";
import AuthProvider from "@/router/authProvider";
import i18n from "@/i18n/config";
import store from "@/store";
import { Provider } from "react-redux";
import CustomSpinLoading from "@/components/CustomSpinLoading";
import "@ant-design/v5-patch-for-react-19";
import { initPerformanceMonitoring } from "@/utils/performance";

// 初始化性能监控
initPerformanceMonitoring();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Suspense fallback={<CustomSpinLoading />}>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <AuthProvider>
            <MapMenusToRouter />
          </AuthProvider>
        </I18nextProvider>
      </Provider>
    </Suspense>
  </StrictMode>
);
